import {
  DefaultPortModel,
  DefaultLinkFactory,
  DefaultLinkModel,
  DefaultLinkWidget
} from "@projectstorm/react-diagrams";
import { ReactText } from "react";
import * as React from "react";
import { OutputType } from "../treeBlockOutputsDataSource";

export class AdvancedLinkModel extends DefaultLinkModel {
  public constructor() {
    super({ type: "advanced" });
  }

  public setId(id: string): void {
    this.options.id = id;
  }
}

export class AdvancedPortModel extends DefaultPortModel {
  private outputType: OutputType;
  private optionId: ReactText | undefined;
  public isAddedByDefault: boolean;
  public constructor(
    isIn: boolean,
    name: string,
    label: string,
    outputType: OutputType,
    optionId: string | number | undefined,
    isAddedByDefault?: boolean
  ) {
    super(isIn, name, label);
    this.outputType = outputType;
    this.isAddedByDefault = isAddedByDefault || false;
    this.optionId = optionId;
  }

  public setOutputType(outputType: OutputType): void {
    this.outputType = outputType;
  }

  public getOutputType(): OutputType {
    return this.outputType;
  }

  public setOptionId(optionId: string): void {
    this.optionId = optionId;
  }

  public getOptionId(): ReactText | undefined {
    return this.optionId;
  }

  //@ts-ignore
  createLinkModel(): AdvancedLinkModel | null {
    return new AdvancedLinkModel();
  }
}

export class AdvancedLinkFactory extends DefaultLinkFactory {
  public constructor() {
    super("advanced");
  }

  generateModel(): AdvancedLinkModel {
    return new AdvancedLinkModel();
  }

  generateReactWidget(event: any): JSX.Element {
    return <DefaultLinkWidget link={event.model} diagramEngine={this.engine} />;
  }
}
